module.exports = __webpack_public_path__ + "static/media/Notification.e56463c3.mp3";